<template>
  <Viewer :c-centers="cCenters" :show-search-area-overlay="showSearchAreaOverlay" @updateFromAreaSearchButton="updateFromAreaSearchButton" />
</template>

<script lang="ts">
import {defineComponent, PropType} from 'vue'
import {CounselingCenterSearchResultDto} from "@/generated/openapi/api";
import Viewer from "@/gis/Viewer.vue";

export default defineComponent({
  name: 'Karte',
  components: { Viewer },
  props: {
    cCenters: Array as PropType<CounselingCenterSearchResultDto[]>,
    showSearchAreaOverlay: {
      type: Boolean,
      default: false
    }
  },
  emits: ['updateFromAreaSearchButton'],
  methods: {
    updateFromAreaSearchButton(object: any) {
      this.$emit("updateFromAreaSearchButton",
        object
      )
    }
  }
});
</script>
